"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    logo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gridRow: function (props) { return props.gridRow; },
        gridColumn: function (props) { return props.gridColumn; },
        gridColumnSpan: function (props) { return props.gridColumnSpan; },
        msGridRow: function (props) { return props.gridRow; },
        msGridColumn: function (props) { return props.gridColumn; },
        msGridColumnSpan: function (props) { return props.gridColumnSpan; },
    },
};
//# sourceMappingURL=Logo.styles.js.map